export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  USER_READ = 'ROLE_USER_READ',
}
